import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';




function AllBenefits(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    const [AllBenefits, setAllBenefits] = useState([]);

    axios.defaults.withCredentials = true;



    

    const getAllBenefits = ()=>{
        axios.post('AllItems', {
            table: 'benefits',
        })
        .then((res) => {
            if (res.data) {
                setAllBenefits(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    





    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }




useEffect(() => {

    getAllBenefits();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <table>

                    <thead>
                        <tr>
                            <th> # </th>
                            <th> Header 1</th>
                            <th> Header 2</th>
                            <th> Header 3</th>

                        </tr>
                    </thead>
                    <tbody>
                    {AllBenefits.length ? (
                    AllBenefits.map((benefit) => {
                        return (
                        <tr key={benefit.id}>
                            
                            <td>
                            <h6>{benefit.id}</h6>
                            </td>


                            <td>
                                <h6>{benefit.header_1}</h6>
                            </td>

                            <td>
                                <h6>{benefit.header_2}</h6>
                            </td>
                            <td>
                                <h6>{benefit.header_3}</h6>
                            </td>
                            <td><Link className='edit' to={`/edit-benefit?id=${benefit.id}`}> <i class="las la-edit"></i> </Link></td>


                        </tr>
                        );
                    })
                    ) : (
                    <tr>
                        <td colSpan={5}>Loading...</td>
                    </tr>
                    )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllBenefits;